module.exports = __webpack_public_path__ + "assets/img/about_culture2.181fff4c.png";